<template>
    <div class="header-container">
      <!-- 导航logo -->
      <img :src="require('@/assets/images/header/logo.png')" alt="图片加载失败" @click="goToHomePage()">
      <!-- 导航内容 -->
      <ul class="navigate-box">
        <li class="navigate-item" v-for="(item,key) in navList" :key="key" @click=" navHoverID = item.id ">
          <router-link v-if="item.path" :to="{path:item.path,}">{{item.name}}</router-link>
          <span class="item" v-else @click="getmessage()">{{item.name}}</span>
        </li>
        <div class="trigger disabled" :style="slider()"></div>
      </ul>
    </div>
</template>

<script>
export default {
    name: 'Header',
    data() {
      return{
          navList:[
            {id:0, name: "首页", path: "/homepage"},
            {id:1, name: "飞视平台", path: "/platform"},
            {id:2, name: "行业应用与案例", path: "/industryApplication"},
            {id:3, name: "新闻动态", path: ""},
            {id:4, name: "关于我们", path: "/about"},
            {id:5, name: "合作与支持", path: ""},
          ],
          navHoverID:null,
          navItemBox:[]
      }
    },
    watch:{
      $route(to, from) {
        // 路由变化时滚动到顶部
        window.scrollTo(0, 0);
      },
    },
    methods:{
      goToHomePage(){
        if (this.$route.path !== '/homepage') {  
            this.$router.push('/homepage');  
        } 
      },
      getmessage(){
        this.$message({
          message: '感谢您的关注，此页面功能尚未开放，敬请期待',
          center:true
        });
      },
      getSlideBox(){ //获取每个item的长度
        let itemBoxes = this.$el.querySelectorAll('.navigate-item');  
        this.navItemBox = Array.from(itemBoxes).map(itemBox => itemBox.offsetWidth); 
      },
      slider() {  
          let left = 0; //向左偏移
          for (let i = 0; i < this.navHoverID; i++) {
            left += this.navItemBox[i] + 48;
            
          }
          let width = this.navItemBox[this.navHoverID];   //当前下划线宽度
          return { marginLeft: `${left}px`, width: `${width}px` };  
      },
    },
    mounted(){
        this.navHoverID = this.$route.meta.id; 
        setTimeout(() => {  
          this.$el.querySelector('.disabled').classList.remove('disabled');  
        }, 300); // 300毫秒 = 0.3秒
        this.getSlideBox();
    }
    
}
</script>
<style scoped lang="scss">
.message-icon{
  display: none;
}
.header-container{
  display: flex;
  align-items: center; /* 垂直居中 */
  left: 0px;
  top: 0px;
  width: 100%;
  height: 64px;
  background-color: rgba(00, 00, 0040, 0); 
  padding:15px 0px;

  img{
    position: absolute;
    width: 88px;
    height: 34px;
    object-fit: contain;
    left: 42px;
    &:hover{
      cursor: pointer;  
    }
  }
  .navigate-box{
    position: absolute;
    margin-bottom: 2px;
    right: 40px;
    width: auto;
    height: 20px;
    background-color: rgba(00, 00, 0040, 0);
    display: flex;
    list-style-type: none; 
    

    .navigate-item{ 
      width: auto;
      height: 20px;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      margin-left: 48px;
      position: relative;

      &:first-child{
        margin: 0;
      }

      a{
        text-decoration: none; /* 去除下划线 */ 
        color: #FFFFFF;
        margin: 0 auto;
      }

      .item{
        color: #FFFFFF;
        margin: 0 auto;
        &:hover{
          cursor: pointer;
        }
      }

    }
    .trigger{
      position: absolute;
      bottom: -6px;
      width: auto;
      height: 2px;  
      background-color: #FFFFFF; /* 线的颜色 */ 
      transition: all 0.3s ease; /*过渡效果*/
    }
    .disabled{
      opacity: 0;
    }
  }
  
}
</style>